import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IDownloadPDFContractResponse,
} from "models/contract/downloadPDF";
import { httpStatus } from "configs/httpStatus";
import { downloadPDFContractInformation } from "services/contractInformation";
import { handleSuccesAction, handleErrorAction } from "./downloadPDFActions";

function* downloadPDFContractSaga() {
  try {
    const response: IDownloadPDFContractResponse = yield call(
      downloadPDFContractInformation
    );

    if (
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusOK
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadPDFContractInformationWatcher() {
  yield takeLatest(
    ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF as any,
    downloadPDFContractSaga
  );
}

export default [fork(onDownloadPDFContractInformationWatcher)];
